import axios from 'axios'
// 工具包
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 5000
})
// request拦截器
service.interceptors.request.use(
  config => {
    // alert(config)
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
service.interceptors.response.use(res => {
  // alert(JSON.stringify(res))
  // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
  // 否则的话抛出错误
  if (res.status === 200) {
    return Promise.resolve(res)
  } else {
    return Promise.reject(res)
  }
},
error => {
  return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/common/axiosHttp.js